/**
 * Shared "forbidden" screen used by role-specific guards. Kept in its own
 * file so guards can share the layout without re-exporting a component
 * from a non-component module (react-refresh/only-export-components).
 */
export function AccessDenied({
  title,
  message,
}: {
  title: string;
  message: string;
}): JSX.Element {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-2 p-8 text-center">
      <h1 className="text-xl font-semibold">{title}</h1>
      <p className="max-w-md text-sm text-neutral-600">{message}</p>
    </div>
  );
}
